module.exports = __webpack_public_path__ + "static/media/pocket-change-home-2-tiny.a23a9971.jpg";